/**
 * webApplicationFirewall模块接口列表
 */
 import $http from '../utils/http'; // 导入http中创建的axios实例

 const webApplicationFirewall = {
    //分页查询弹性伸缩接口
    pageWebApplicationFirewall(params) {
        return $http.post(`${global.API_URL}/sme/aliWaf/page`,params);
      },
    //删除
    delete(id ,params) {
      let param = new URLSearchParams();
      param.append(id, params);
      return $http.post(`${global.API_URL}/sme/aliWaf/delete`,param);
    },
    //nat网关详情
    getWafDetail(params) {
    return $http.post(`${global.API_URL}/sme/aliWaf/getWafDetail`,params);
  },
 }
 
 export default webApplicationFirewall;
 


// WEBPACK FOOTER //
// ./src/api/webApplicationFirewall.js